import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form-single-toggle',
  templateUrl: './form-single-toggle.component.html',
  styleUrls: ['./form-single-toggle.component.scss']
})
export class FormSingleToggleComponent implements OnInit {
  val: boolean;

  @Input() label: string;
  @Input() get value() {
    return this.val;
  } set value(val) {
    this.val = val;
    this.valueChange.emit(this.val);
  }
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {
   }

  ngOnInit() {
  }

  valueClicked(): void {
    if (this.value === false) {
      this.value = true;
    } else {
      this.value = false;
    }
  }

}
